import { saveAs } from "file-saver";
import consumer from "./consumer";

function showDownloadError(message) {
  const alert = document.createElement("div");
  alert.className = "m-alert m-alert--error";
  alert.setAttribute("role", "alert");
  alert.innerHTML = "<p></p><button type=\"button\">+</button>";
  alert.querySelector("p").textContent = message;
  alert.querySelector("button").addEventListener("click", () => alert.remove());
  const main = document.querySelector("main");
  (main ? main.parentNode : document.body).insertBefore(alert, main || document.body.firstChild);
}

consumer.subscriptions.create(
  {
    channel: "DownloadsChannel"
  },
  {
    received(data) {
      if (data.error) {
        console.error("File download error:", data.error);
        showDownloadError(data.error);
        return;
      }
      try {
        const blob = new Blob([data.csv], { type: "text/csv;charset=utf-8" });
        saveAs(blob, data.filename);
      } catch (e) {
        console.error("File download error:", e);
      }
    }
  }
);
